// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xCartStateType = Readonly<{
    adjustedCartLineId?: string;
}>;

export const initialXCart: xCartStateType = {
    adjustedCartLineId: undefined,
};

const reducer = {
    "xCart/setAdjustedLineId": (draft: Draft<xCartStateType>, action: { adjustedCartLineId?: string }) => {
        draft.adjustedCartLineId = action.adjustedCartLineId;
    },
};

const xCart = createTypedReducerWithImmer(initialXCart, reducer);

(reducers as any).xCart = xCart;

export type xCartState = {
    xCart: xCartStateType;
} & ApplicationState;

type xCartReducers = {
    [key: string]: typeof xCart;
};

export type xCartActions = Parameters<xCartReducers[keyof xCartReducers]>[1] | AnyAction;
